<!-- TOAST LOADING -->
<template>
  <div class="MIDAS-TOAST-loading" v-if="isLoading">
    <p class="MIDAS-TOAST-loading__txt">
      <i class="MIDAS-TOAST-loading__icon icon-load"></i>
      加载中，请稍候...
    </p>
  </div>
</template>
<script>
export default {
  props: ["isLoading"]
}
</script>
